export default __webpack_public_path__ + "static/media/five_of_wands.570d3a68.png";